import React from "react";
import classNames from "classnames";
import { TimelineProps } from "./PropsType";

export default function Timeline(props: TimelineProps) {
  const { className, children, prefixCls = "bm-Timeline", ...other } = props;
  const styleClass = classNames(prefixCls, className);
  return (
    <div className={styleClass} {...other}>
      {children}
    </div>
  );
}
